export const permissions = {
  super_admin: [
    "access_dashboard",
    "smtp_configuration",
    "database_configuration",
  ],
  admin: [
    "access_dashboard",
    "add_user",
    "smtp_configuration",
    "database_configuration",
  ],
  explorer: ["access_dashboard"],
};
